import { wordPluralisation } from '@nocowanie/common-ui/helpers';

import { AccommodationTileProps } from '@app/components/molecules/accommodation-tile';
import { getRatingDescValue } from '@app/helpers/get-rating-desc-value';
import { RatingDescription } from '@app/models/rating-description.model';

import s from './accommodation-tile-lite.module.css';

interface TileRatingProps {
    ratingAverage?: number;
    ratingCount?: number;
    ratingDescription?: unknown;
    t: AccommodationTileProps['t'];
}

/** Same markup as `Rating` with the `accommodationTile` variant, without Chakra runtime styling */
export const TileRating = ({
    ratingAverage,
    ratingCount,
    ratingDescription,
    t,
}: TileRatingProps) => {
    const hasRating = !!(ratingAverage && ratingCount && ratingDescription);
    const opinions = t('opinions', { returnObjects: true }) as Record<string, string>;

    return (
        <div data-testid={'acc-tile-rating'} className={ratingAverage ? s.rating : s.ratingEmpty}>
            {hasRating ? (
                <div data-testid={'rating'} className={s.ratingInner}>
                    <span data-testid={'rating-average'} className={s.ratingAverage}>
                        {/* Same formatting as `RatingRate` */}
                        {(ratingAverage as number) < 9.96
                            ? (ratingAverage as number).toFixed(1)
                            : (ratingAverage as number).toFixed(0)}
                    </span>
                    <div className={s.ratingDescription}>
                        <div data-testid={'rating-text'} className={s.ratingText}>
                            {getRatingDescValue(ratingDescription as RatingDescription)}
                        </div>
                        <span data-testid={'rating-count'} className={s.ratingCount}>
                            {ratingCount}{' '}
                            {wordPluralisation(
                                ratingCount as number,
                                opinions.singular,
                                opinions.plural,
                                opinions.genitivePlural,
                            )}
                        </span>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
